// extracted by mini-css-extract-plugin
module.exports = {"chevron":"ChevronButton_chevron__XuxUk","right":"ChevronButton_right__CTMT1","disabled":"ChevronButton_disabled__L7Hky"};